import { VisualizationModule } from '@core/models/data-visualization/data-visualization.model';
import { CustomData } from '@core/models/entities/implementations/custom-data';

import { FilterDataType } from '@shared/components/filter-query-builder/filter.models';

import {
  AuxiliaryDataFetchDetails,
  EntityCfg,
  EntityInterface,
  TableColCfg
} from '../entity-visualization-interface';

export interface UserCommodityV1Model {
  uid: string;
  name: string;
  temperature_uids?: string[];
  custom_data: CustomData;
}
type RawModel = UserCommodityV1Model;

export class UserCommodityCfg implements EntityCfg<RawModel> {
  static readonly visus = new Set<VisualizationModule>([]);

  supportedVisualizations(): Set<VisualizationModule> {
    return UserCommodityCfg.visus;
  }

  versionName(): string {
    return 'UserCommodity';
  }

  defaultSortingCol(): string[] {
    return ['name'];
  }

  availableDetailEntityType(): string[] {
    return [];
  }

  makeAuxDataFetchDetails(_entities: RawModel[]): AuxiliaryDataFetchDetails {
    return {
      versionNameAndUidsPerType: {}
    };
  }

  buildColumns(): TableColCfg<EntityInterface<RawModel>>[] {
    const cols: TableColCfg<EntityInterface<RawModel>>[] = [
      {
        key: 'raw.uid' as keyof EntityInterface<RawModel>,
        label: 'table.columns.uid',
        type: 'string',
        cellTemplate: 'default',
        sortCfg: { dbColName: 'uid' },
        filterCfg: {
          translationLabel: 'uid',
          dbColName: 'uid',
          filterType: FilterDataType.TEXT
        }
      },
      {
        key: 'raw.name' as keyof EntityInterface<RawModel>,
        label: 'table.columns.name',
        type: 'string',
        cellTemplate: 'default',
        sortCfg: { dbColName: 'name' },
        filterCfg: {
          translationLabel: 'name',
          dbColName: 'name',
          filterType: FilterDataType.TEXT,
          supportRegexFiltering: true
        }
      },
      {
        key: 'raw.temperature_uids' as keyof EntityInterface<RawModel>,
        label: 'table.columns.temperature',
        type: 'uid-list',
        cellTemplate: 'default',
        filterCfg: {
          translationLabel: 'temperature',
          dbColName: 'temperature_uids',
          filterType: FilterDataType.UID_LIST,
          uidEntityType: 'TEMPERATURE'
        }
      },
      {
        key: 'raw.custom_data.tags' as keyof EntityInterface<RawModel>,
        label: 'table.columns.tags',
        type: 'uid-list',
        filterCfg: {
          translationLabel: 'tags',
          dbColName: 'tags',
          filterType: FilterDataType.TAGS
        }
      },
      {
        key: 'raw.custom_data.labels' as keyof EntityInterface<RawModel>,
        label: 'table.columns.custom_labels',
        type: 'string-number-map',
        filterCfg: {
          translationLabel: 'custom_labels',
          dbColName: 'labels',
          filterType: FilterDataType.LABELS
        }
      }
    ];

    return cols;
  }
}

export class UserCommodityV1 implements EntityInterface<RawModel> {
  constructor(public raw: RawModel) {}

  supportedVisualizations(): Set<VisualizationModule> {
    return UserCommodityCfg.visus;
  }

  get uid(): string {
    return this.raw.uid;
  }

  getDetailsCfg(): EntityCfg<unknown> | undefined {
    return undefined;
  }

  getDetails(): EntityInterface<unknown>[] {
    return [];
  }
}
